import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function OtherDSSPaymentWise() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const { isAuthenticated, companyId, companyName, branchId, permissions, token, logout } = useAuth();
    const [totalcgst, setTotalcgst] = useState(0);
    const [totalsgst, setTotalsgst] = useState(0);
    const [totaligst, setTotaligst] = useState(0);
    const [totalnet, setTotalnet] = useState(0);
    const [totalamt, setTotalamt] = useState(0);
    const [totalpurchase, setTotalpurchase] = useState(0);
    const [totalqty, setTotalqty] = useState(0);
    const [isFocused, setIsFocused] = useState(false);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchName, setBranchName] = useState(0);
    const [selectedBranches, setSelectedBranches] = useState([]); // Use an array for multiple selections

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
        fetchBranchData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const handleBranchSelect = (selectedOptions) => {
        setSelectedBranches(selectedOptions);
        const branchIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // You can now use branchIds to filter or send to the API
        setDataItem([]); // Clear the data when branches are changed
    };

    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    const [totalbills, setTotalbills] = useState(0);
    const [totalMRP, settotalMRP] = useState(0);
    const [totalMRPONNET, settotalMRPONNET] = useState(0);
    const [totalDiscValue, settotalDiscValue] = useState(0);
    const [totalAddDiscValue, settotalAddDiscValue] = useState(0);
    const [totalCashDisc, settotalCashDisc] = useState(0);
    const [totalpurchasevalue, settotalpurchasevalue] = useState(0);
    const [totalcash, settotalcash] = useState(0);
    const [totaldigital, settotaldigital] = useState(0);
    const [totalother, settotalother] = useState(0);
    useEffect(() => {
        // Calculate totals
        let totalcgst = 0;
        let totalsgst = 0;
        let totaligst = 0;
        let totalnet = 0;
        let totalamt = 0;
        let totalpurchase = 0;
        let qty = 0;
        let billNumbers = new Set();
        let totalMRP = 0;
        let totalMRPONNET = 0;
        let totalDiscValue = 0;
        let totalAddDiscValue = 0;
        let totalCashDisc = 0;
        let totalpurchasevalue = 0;
        let totalcash = 0;
        let totaldigital = 0;
        // let totalother = 0;

        dataItem.forEach(item => {
            totalcgst += item.CGSTAmount;
            totalsgst += item.SGSTAmount;
            totaligst += item.IGSTAmount;
            totalnet += item.TaxableAmount;
            totalamt += item.TotalAmount;
            totalpurchase += item.PurchaseAmount;
            totalMRP += item.Rate;
            totalMRPONNET += item.Amount;
            totalDiscValue += item.DiscountAmount;
            totalAddDiscValue += item.AdditionalDiscountAmount;
            totalCashDisc += item.CashDiscount;
            totalpurchasevalue += item.PurchaseRate;
            totalcash += item.CashAmount;
            totaldigital += item.DigitalAmount;
            //totalother += item.UPIAmount;
            qty += item.Quantity;
            billNumbers.add(item.BillNumber); // Collect unique BillNumbers
        });

        setTotalcgst(totalcgst);
        setTotalsgst(totalsgst);
        setTotaligst(totaligst);
        setTotalnet(totalnet);
        setTotalamt(totalamt);
        setTotalqty(qty);
        setTotalpurchase(totalpurchase);
        settotalMRP(totalMRP);
        settotalMRPONNET(totalMRPONNET);
        settotalDiscValue(totalDiscValue);
        settotalAddDiscValue(totalAddDiscValue);
        settotalCashDisc(totalCashDisc);
        settotalpurchasevalue(totalpurchasevalue);
        settotalcash(totalcash);
        settotaldigital(totaldigital);
        // settotalother(totalother);
        const totalBills = billNumbers.size;
        setTotalbills(totalBills);
    }, [dataItem]);

    const fetchCustomerData = () => {
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            let branchIds;

            if (selectedBranches.length === 0) {
                branchIds = branchOptions.map(branch => branch.value);
            } else {
                branchIds = selectedBranches.map(branch => branch.value);
            }
            try {
                const branchIdsString = branchIds.join(',');
                const response = await fetchData('OtherReportApi', `/DailySalesSummaryPayment/${companyId}/${branchIdsString}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Daily Sales Summary Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('DSS Payment Wise');

        // Define headers (based on your TableCell JSX)
        const headerRowValues = [
            'Branch Name', 'Date', 'Bill No', 'Item No', 'Description', 'HSN Code', 'Quantity', 'MRP', 'MRP On Net',
            'Disc %', 'Disc value', 'Additional Disc%', 'Add Disc Value', 'Cash Disc', 'Balance',
            'GST %', 'CGST', 'SGST', 'IGST', 'Net Value', 'Gift Voucher', 'Net Value + Tax',
            'Purchase Rate', 'Total Purchase Value', 'Mode Of Pay', 'Cash', 'Digital', 'DISC Type',
            'GST No', 'Sales Man', 'Comments', 'GWP/PWP', 'Style', 'Brand', 'Customer',
            'Contact No', 'Address'
        ];

        const rightAlignColumns = [
            'Quantity', 'MRP', 'MRP On Net', 'Disc %', 'Disc value', 'Additional Disc%',
            'Add Disc Value', 'Cash Disc', 'Balance', 'GST %', 'CGST', 'SGST', 'IGST',
            'Net Value', 'Gift Voucher', 'Net Value + Tax', 'Purchase Rate',
            'Total Purchase Value', 'Cash', 'Digital'
        ];

        // Title caption
        worksheet.mergeCells('A1:AN1');
        const captionCell = worksheet.getCell('A1');
        captionCell.value = `${companyName} - DSS (BW) Payment Wise From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`;
        captionCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        captionCell.font = { bold: true, size: 14 };
        captionCell.alignment = { vertical: 'middle', horizontal: 'left' };

        const headerRow = worksheet.addRow(headerRowValues);
        const thinBorder = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        // Header styling
        headerRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB6D7A8' } };
            cell.font = { bold: true };
            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
            cell.border = thinBorder;
        });

        // Add data rows
        filteredDataItem.forEach(rowData => {
            const rowValues = [
                rowData.BranchName,
                formatDate(rowData.BillDate),
                rowData.BillNumber,
                parseFloat(rowData.Code),
                rowData.ItemName,
                rowData.HSNCode,
                rowData.Quantity,
                rowData.Rate,
                rowData.Amount,
                rowData.DiscountPercentage,
                rowData.DiscountAmount,
                rowData.AdditionalDiscountPercentage,
                rowData.AdditionalDiscountAmount,
                rowData.CashDiscount,
                rowData.TotalAmount,
                rowData.GSTRate,
                rowData.CGSTAmount,
                rowData.SGSTAmount,
                rowData.IGSTAmount,
                rowData.TaxableAmount,
                rowData.GiftVoucher || '', // optional field
                rowData.TotalAmount,
                rowData.PurchaseRate,
                rowData.PurchaseAmount,
                rowData.ModeOfPayment,
                rowData.CashAmount,
                rowData.DigitalAmount,
                // rowData.UPIAmount,
                // rowData.CardType,
                // rowData.CardNumber,
                // rowData.UPINumber,
                rowData.DiscType,
                rowData.GSTNumber,
                rowData.SalesManName,
                rowData.Remarks,
                rowData.Gwp,
                rowData.StyleName,
                rowData.BrandName,
                rowData.CustomerName,
                rowData.ContactNumber,
                rowData.CustomerAddress
            ];

            const row = worksheet.addRow(rowValues);
            row.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                if (rightAlignColumns.includes(headerName)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }
                cell.border = thinBorder;
            });
        });

        const totalRowValues = [
            '', '', '', '', 'Total Bills', totalbills,
            totalqty, totalMRP, totalMRPONNET, '', totalDiscValue.toFixed(2),
            '', totalAddDiscValue.toFixed(2), totalCashDisc.toFixed(2), totalamt.toFixed(2),
            '', totalcgst.toFixed(2), totalsgst.toFixed(2), totaligst.toFixed(2), totalnet.toFixed(2),
            '', totalamt.toFixed(2), totalpurchasevalue.toFixed(2), totalpurchase.toFixed(2),
            '', totalcash.toFixed(2), totaldigital.toFixed(2),
            '', '', '', '', '', '', '', '', '', ''
        ];

        const totalRow = worksheet.addRow(totalRowValues);
        totalRow.font = { bold: true };
        totalRow.eachCell((cell, colNumber) => {
            const headerName = headerRowValues[colNumber - 1];
            if (rightAlignColumns.includes(headerName)) {
                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                cell.numFmt = '#,##0.00';
            } else {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } };
            cell.border = thinBorder;
        });

        // Adjust column width
        worksheet.columns = headerRowValues.map(() => ({ width: 15 }));

        // Export to Excel
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'DSS_Branch Payment Wise.xlsx');
    };

    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];

    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', width: '250px' }}>
                        DSS Payment Wise
                    </h6>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace', marginLeft: '-50px' }}>
                        Total net value : <span style={{ color: 'red', fontWeight: 'bold' }}>{totalnet.toFixed(2)}</span>
                    </label>
                </div>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}

                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '270px' : '200px',
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>

                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            {/* <RefreshIcon style={{ color: 'brown' }} /> */}
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder', fontSize: '12px' }}>Refresh</span>
                    </Button>
                    <Button
                         style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            {/* <FeedIcon style={{ color: 'darkgreen' }} /> */}
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder', fontSize: '12px' }}>Excel</span>
                    </Button>

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>
                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '50px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ width: '100%', maxWidth: '30%', marginLeft: '10px', paddingRight: '5', marginRight: '10px', marginBottom: '2', flexBasis: 'auto' }}>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        Branch
                        <span style={{ color: 'red' }}>*</span>
                    </label>

                    <Select
                        options={branchOptionsWithBlank}
                        value={selectedBranches}
                        onChange={handleBranchSelect}
                        placeholder="Select a Branch"
                        isMulti
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '30px',
                                fontSize: '13px',
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                                fontSize: '13px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: '30px',
                            }),
                        }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#7b1107ff', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Store</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item No</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Quantity</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>MRP</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>MRP On Net</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Disc %</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Disc value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Additional Disc%</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Add Disc Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Cash Disc</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Balance</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST %</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>CGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>SGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>IGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Net Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Gift Voucher</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Net Value + Tax</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Rate</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Total Purchase Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Mode Of Pay</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Cash </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Digital </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>DISC Type</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST No</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sales Man</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Comments</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>GWP/PWP</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Style</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Brand</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Customer</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Contact No</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}> Address</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {/* {filteredDataItem.map((data, index) => ( */}
                            {filteredDataItem.map((data, index) => {
                                // Check if this is the first occurrence of the BillNumber
                                const isFirstOfBill =
                                    index === 0 || data.BillNumber !== filteredDataItem[index - 1].BillNumber;

                                return (
                                    <TableRow
                                        key={data.id}
                                        className={data.routeName === 'Total' ? 'highlighted-row' : ''}
                                        sx={{
                                            padding: '7px',
                                            backgroundColor: data.routeName === 'Total' ? 'teal' : 'transparent',
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', color: 'black', background: '#FDAB9E', }}>{data.BranchName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{formatDate(data.BillDate)} {data.BillTime}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.BillNumber}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.Code}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'left', width: '100%' }}>{data.ItemName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.HSNCode}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.Quantity}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.Rate ? data.Rate.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.Amount ? data.Amount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.DiscountPercentage}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.DiscountAmount ? data.DiscountAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.AdditionalDiscountPercentage}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.AdditionalDiscountAmount ? data.AdditionalDiscountAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.CashDiscount ? data.CashDiscount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.TotalAmount ? data.TotalAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.GSTRate}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.CGSTAmount ? data.CGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.SGSTAmount ? data.SGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.IGSTAmount ? data.IGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.TaxableAmount ? data.TaxableAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.TotalAmount ? data.TotalAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.PurchaseRate ? data.PurchaseRate.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.PurchaseAmount ? data.PurchaseAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.ModeOfPayment}</TableCell>
                                        {/* <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.CashAmount ? data.CashAmount.toFixed(2) : "0.00"}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.DigitalAmount ? data.DigitalAmount.toFixed(2) : "0.00"}</TableCell> */}
                                        {/* ✅ Show these only once per BillNumber */}
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid black',
                                                borderRight: '1px solid grey',
                                                color: 'black',
                                                fontWeight: 'bolder',
                                                padding: '3px',
                                                textAlign: 'right',
                                                fontSize: '10.5px',
                                            }}
                                        >
                                            {isFirstOfBill ? (data.CashAmount ? data.CashAmount.toFixed(2) : '0.00') : '-'}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid black',
                                                borderRight: '1px solid grey',
                                                color: 'black',
                                                fontWeight: 'bolder',
                                                padding: '3px',
                                                textAlign: 'right',
                                                fontSize: '10.5px',
                                            }}
                                        >
                                            {isFirstOfBill ? (data.DigitalAmount ? data.DigitalAmount.toFixed(2) : '0.00') : '-'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.DiscType}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.GSTNumber}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.SalesManName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.Remarks}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.Gwp}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.StyleName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px', textAlign: 'center' }}>{data.BrandName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>{data.CustomerName}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>{data.ContactNumber}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>{data.CustomerAddress}</TableCell>
                                    </TableRow>
                                );
                            })}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '30px',
                                    background: 'linear-gradient(to right, #063e68ff, #063e68ff)',
                                }}
                            >
                                <TableCell colSpan={4} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '9px', textTransform: 'uppercase' }}>Total Bills</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalbills}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{totalqty}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalMRP}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalMRPONNET}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalDiscValue.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalAddDiscValue.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalCashDisc.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalamt.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalcgst.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalsgst.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totaligst.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalnet.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalamt.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalpurchasevalue.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalpurchase.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalcash.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totaldigital.toFixed(2)}</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalother.toFixed(2)}</TableCell> */}
                                <TableCell colSpan={20} />
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}

export default OtherDSSPaymentWise;
